// Lib
import { defer } from 'lodash/fp';

// Utils
import logger from '../../../utils/logger';
import { getClosestUpTaskListId, getElement } from '../../../../common/elements/utils/elementTraversalUtils';
import { length } from '../../../../common/utils/immutableHelper';

// Selectors
import { getElements } from '../../selectors/elementsSelector';
import { getSelectedElementIds } from '../../selection/selectedElementsSelector';

// Actions
import { finishEditingElement, setSelectedElements, startEditingMainEditor } from '../../selection/selectionActions';
import { getCurrentlyEditingId } from '../../selection/currentlyEditingSelector';
import { isTaskList } from '../../../../common/elements/utils/elementTypeUtils';
import { parentIdMapSelector } from '../../selectors/elementGraphSelector';
import { getAllAncestorIds } from '../../../../common/dataStructures/treeUtils';

export const dispatchGetParentTaskListId =
    ({ elementId }) =>
    (dispatch, getState) => {
        const state = getState();

        const elements = getElements(state);

        return getClosestUpTaskListId(elements, elementId);
    };

export const dispatchGetIsCurrentlyEditingElement =
    ({ elementId }) =>
    (dispatch, getState) => {
        const state = getState();
        const currentlyEditingId = getCurrentlyEditingId(state);
        return currentlyEditingId === elementId;
    };

export const dispatchGetIsOnlyParentTaskListSelected =
    ({ elementId }) =>
    (dispatch, getState) => {
        const state = getState();

        const selectedElementIds = getSelectedElementIds(state);

        // If more than one element is selected then the parent task list isn't the only thing selected
        if (length(selectedElementIds) !== 1) return false;

        const taskListId = dispatch(dispatchGetParentTaskListId({ elementId }));

        if (!taskListId) {
            logger.warning("Unable to find Task's parent Task List", elementId);
            return false;
        }

        return selectedElementIds.first() === taskListId;
    };

export const selectParentTaskList =
    ({ elementId }) =>
    (dispatch) => {
        const taskListId = dispatch(dispatchGetParentTaskListId({ elementId }));
        return dispatch(setSelectedElements({ ids: [taskListId] }));
    };

export const returnFocusFromPillPopup =
    ({ elementId, initiallyEditing }) =>
    (dispatch, getState) => {
        if (!initiallyEditing) return dispatch(finishEditingElement(elementId));

        defer(() => {
            const state = getState();
            const elements = getElements(state);

            const selectedElementIds = getSelectedElementIds(state);

            // If there's no selected elements or there's more than one, then don't return focus to the editor
            if (length(selectedElementIds) !== 1) return dispatch(finishEditingElement(elementId));

            const selectedElementId = selectedElementIds.first();
            const selectedElement = getElement(elements, selectedElementId);

            // If it's not a task list then don't return focus to the editor
            if (!isTaskList(selectedElement)) return dispatch(finishEditingElement(elementId));

            const parentIdMap = parentIdMapSelector(state);
            const ancestorIds = getAllAncestorIds({ parentIdMap, startingId: elementId });

            // If the selected element is not the task list parent, then don't return focus to the editor
            if (!ancestorIds.includes(selectedElementId)) return dispatch(finishEditingElement(elementId));

            dispatch(startEditingMainEditor(elementId));
        });
    };
